(function () {
  'use strict';

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var REQUIRED = ['fullName', 'email', 'phone', 'projectType', 'message'];

  function init(root) {
    var form = root.querySelector('[data-contact-form]');
    if (!form) return;

    var submitBtn = root.querySelector('[data-contact-submit]');
    var successEl = root.querySelector('[data-contact-success]');
    var errorEl = root.querySelector('[data-contact-error]');
    var endpoint = root.getAttribute('data-api-endpoint') || '';
    var defaultLabel = 'Send Inquiry';

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      hideAlerts();

      if (!validate(form)) return;

      if (!endpoint || endpoint.indexOf('YOUR-VERCEL-PROJECT') !== -1) {
        showError();
        return;
      }

      setLoading(true);

      var payload = collectPayload(form);

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Request failed');
          return res.json();
        })
        .then(function (data) {
          if (!data || data.success !== true) throw new Error('Unsuccessful');
          form.reset();
          clearInvalid(form);
          showSuccess();
        })
        .catch(function () {
          showError();
        })
        .finally(function () {
          setLoading(false);
        });
    });

    form.addEventListener('input', function (e) {
      var field = e.target;
      if (field && field.classList && field.classList.contains('is-invalid')) {
        if (isFieldValid(field)) {
          field.classList.remove('is-invalid');
        }
      }
    });

    function collectPayload(formEl) {
      var fd = new FormData(formEl);
      return {
        fullName: (fd.get('fullName') || '').toString().trim(),
        email: (fd.get('email') || '').toString().trim(),
        phone: (fd.get('phone') || '').toString().trim(),
        projectType: (fd.get('projectType') || '').toString().trim(),
        location: (fd.get('location') || '').toString().trim(),
        message: (fd.get('message') || '').toString().trim(),
        companyWebsite: (fd.get('companyWebsite') || '').toString().trim()
      };
    }

    function isFieldValid(field) {
      var name = field.name;
      var val = (field.value || '').trim();

      if (REQUIRED.indexOf(name) === -1) return true;

      if (!val) return false;
      if (name === 'email') return EMAIL_RE.test(val);
      if (name === 'projectType') return val !== '';
      return true;
    }

    function validate(formEl) {
      var valid = true;

      REQUIRED.forEach(function (name) {
        var field = formEl.querySelector('[name="' + name + '"]');
        if (!field) return;

        if (!isFieldValid(field)) {
          field.classList.add('is-invalid');
          valid = false;
        } else {
          field.classList.remove('is-invalid');
        }
      });

      if (!valid) {
        var first = formEl.querySelector('.is-invalid');
        if (first) first.focus();
      }

      return valid;
    }

    function clearInvalid(formEl) {
      formEl.querySelectorAll('.is-invalid').forEach(function (el) {
        el.classList.remove('is-invalid');
      });
    }

    function hideAlerts() {
      if (successEl) successEl.hidden = true;
      if (errorEl) errorEl.hidden = true;
    }

    function showSuccess() {
      if (successEl) {
        successEl.hidden = false;
        successEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    function showError() {
      if (errorEl) {
        errorEl.hidden = false;
        errorEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    function setLoading(loading) {
      if (!submitBtn) return;
      submitBtn.disabled = loading;
      submitBtn.innerHTML = loading
        ? 'Sending…'
        : defaultLabel + ' <span class="wd-contact-page__arrow" aria-hidden="true">→</span>';
    }
  }

  function boot() {
    document.querySelectorAll('wd-contact-page.wd-contact-page, .wd-contact-page[data-section-id]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
